import { getApprovalById } from "@/services/approvals.service";
import { useQuery } from "@tanstack/react-query";

export const useApproval = (module, id, options = {}) => {
  return useQuery({
    queryKey: ["approval", module, id],
    queryFn: () => getApprovalById({ module, id }),
    enabled: Boolean(module) && Boolean(id),
    ...options,
  });
};
